import { createReducer } from "../../../../app/common/util/reducerUtil";
import { FETCH_MERCHANT_TRANSACTIONS } from "./transactionsConstants";

const initialState = [];

export const getTransactionsForDashboard = (state, payload) => {
  // console.log('payload',payload)

  return payload.merchantTransactions;
};

export default createReducer(initialState, {
  [FETCH_MERCHANT_TRANSACTIONS]: getTransactionsForDashboard
});
